import {
  IYuzVeri,
  IKullaniciEtiket,
  ICozumlenmisEtiket,
  EtiketKaynagi,
} from '../interfaces/yuz-tanima.interface';

/**
 * Bir resimdeki yüzler için öncelik sırasına göre etiket çözümler.
 *
 * Öncelik sırası:
 * 1. Görenin kendi etiketi (görüntüleyen kullanıcının verdiği isim)
 * 2. Paylaşanın etiketi (içeriği paylaşan kişinin verdiği isim)
 * 3. "Bilinmeyen" (etiket yoksa)
 *
 * @param yuzler          Resimdeki ham yüz verileri (bbox + kisiGrupId bilgisi ile)
 * @param goruntuleyenEtiketleri  kisiGrupId → IKullaniciEtiket (görüntüleyen kullanıcının etiketleri)
 * @param paylasanEtiketleri      kisiGrupId → IKullaniciEtiket (paylaşan kullanıcının etiketleri)
 * @param paylasanAdi    Paylaşan kullanıcı adı (kaynak bilgisi için)
 */
export function etiketleriCozumle(
  yuzler: IYuzVeri[],
  goruntuleyenEtiketleri: Map<string, IKullaniciEtiket>,
  paylasanEtiketleri: Map<string, IKullaniciEtiket>,
  paylasanAdi?: string,
): ICozumlenmisEtiket[] {
  return yuzler.map((yuz): ICozumlenmisEtiket => {
    const grupId = yuz.kisiGrupId;

    // 1. Görüntüleyen kullanıcının etiketi (en yüksek öncelik)
    if (grupId) {
      const kendi = goruntuleyenEtiketleri.get(grupId);
      if (kendi && !kendi.gizli) {
        return {
          bbox: yuz.bbox,
          kisiGrupId: grupId,
          isim: kendi.isim,
          kaynak: 'kendi' as EtiketKaynagi,
          soyagaciKisiId: kendi.soyagaciKisiId,
          resimUrl: kendi.resimUrl,
        };
      }
    }

    // 2. Paylaşan kullanıcının etiketi (ikinci öncelik)
    if (grupId) {
      const paylasan = paylasanEtiketleri.get(grupId);
      if (paylasan && !paylasan.gizli) {
        return {
          bbox: yuz.bbox,
          kisiGrupId: grupId,
          isim: paylasan.isim,
          kaynak: 'paylasan' as EtiketKaynagi,
          kaynakKullaniciAdi: paylasanAdi,
          soyagaciKisiId: paylasan.soyagaciKisiId,
          resimUrl: paylasan.resimUrl,
        };
      }
    }

    // 3. Bilinmeyen (etiket yok)
    return {
      bbox: yuz.bbox,
      kisiGrupId: grupId,
      isim: 'Bilinmeyen',
      kaynak: 'bilinmeyen' as EtiketKaynagi,
    };
  });
}
